import { I18nProvider } from "../_metronic/i18n/i18nProvider";
import { LayoutProvider, LayoutSplashScreen } from "../_metronic/layout/core";
import { MasterInit } from "../_metronic/layout/MasterInit";
import { Outlet } from "react-router-dom";
import { ReactComponent as RightIconForAlert } from "../../src/app/newLayout/assets/svgIcon/listView/RightIconForAlert.svg";
import { ShopifyBillingBanner } from "./integrationV1/shopify/components/ShopifyBillingBanner";
import { SetupGuideRoot } from "./onboarding/SetupGuideRoot";
import { LeaveGuardProvider } from "./shared/leaveGuard/LeaveGuardProvider";
import { ShopifyScopesBanner } from "./integrationV1/shopify/components/ShopifyScopesBanner";
import { NotificationInboxBootstrap } from "./notification/NotificationInboxBootstrap";
import { isAuthenticated } from "../store/slice/authSlice";
import { setNotification } from "../store/slice/miscSlice";
import { Suspense } from "react";
import { ThemeModeProvider } from "../_metronic/partials";
import { ToastContainer, toast } from "react-toastify";
import { ToastWithActions } from "../components/molecules/ToastWithActions";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { WarningWhite } from "../assets/icons";

const App = () => {
  const dispatch = useDispatch();

  const notification = useSelector(state => state.misc.notification);
  const isAuth = useSelector(isAuthenticated);

  useEffect(() => {
    // Ensure notification object exists and has a type property
    if (notification && notification.type && toast[notification.type]) {
      let toastProps = {
        autoClose: 5000,
        closeOnClick: true,
        draggable: false,
        hideProgressBar: true,
        pauseOnHover: true,
        position: notification.position ? notification.position : "top-right",
        theme: "colored",
      };

      if (notification.type === "success") {
        toastProps = { ...toastProps, icon: <RightIconForAlert />, position: "top-center" };
      } else if (notification.type === "error" || notification.type === "warning") {
        toastProps = { ...toastProps, icon: <WarningWhite />, position: "top-center" };
      }

      if (notification.actions?.length) {
        const { message, actions } = notification;
        toast[notification.type](
          ({ closeToast }) => (
            <ToastWithActions message={message} actions={actions} closeToast={closeToast} />
          ),
          { ...toastProps, autoClose: 8000, closeOnClick: false },
        );
      } else {
        toast[notification.type](notification.message, toastProps);
      }
      dispatch(setNotification(null));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notification]);

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          <ThemeModeProvider>
            <ToastContainer style={{ maxWidth: window.innerWidth - 50, width: "max-content" }} />
            {isAuth === true ? <NotificationInboxBootstrap /> : null}
            {isAuth === true ? <ShopifyScopesBanner /> : null}
            {isAuth === true ? <ShopifyBillingBanner /> : null}
            {isAuth === true ? (
              <LeaveGuardProvider>
                <SetupGuideRoot>
                  <Outlet />
                </SetupGuideRoot>
              </LeaveGuardProvider>
            ) : (
              <Outlet />
            )}
            <MasterInit />
          </ThemeModeProvider>
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  );
};

export { App };
